/*
 * @Author: Musa Tabitay
 * @Date: 2019-11-12 22:49:22
 * @LastEditTime: 2020-03-01 19:36:14
 */
import Vue from 'vue'
import Vuex from 'vuex'
import baseUrl from '../util/index'

Vue.use(Vuex)
const state = {
  nickname: '',
  avatar: '',
  siteDomain: `${baseUrl}`,
  uploadDomain: `${baseUrl}/upload`
}
const mutations = {
  setNikeName (state, nickname) {
    state.nickname = nickname
    localStorage.setItem('nickname', nickname)
  },
  setAvatar (state, avatar) {
    state.avatar = avatar
    localStorage.setItem('avatar', avatar)
  }
}
const actions = {}
const getters = {
  nickname: state => localStorage.getItem('nickname'),
  avatar: state => localStorage.getItem('avatar')
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js